import React from 'react';

import { POSSIBLE_FILTERS_ENTITIES } from '../../../../../../hooks/useMemorizeInputsFilters';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import LeadService from '../../../services/leadService';
import ImportDataForm from 'components/ImportData';
import { defaultImportFields } from 'components/ImportData/data/fields';

/**
 * Componente ImportLeadsModal para gerenciar a importação de dados de leads.
 *
 * @component
 * @param {Object} props - Propriedades do componente
 * @param {boolean} props.isOpen - Controla se o modal está visível
 * @param {Function} props.setIsOpen - Função para alternar a visibilidade do modal
 * @param {string|number} props.recordTypeId - ID do tipo de registro para os leads estão sendo importados
 *
 * @returns {JSX.Element} A interface do modal de importação de contas
 */

const ImportLeadsModal = ({ isOpen, setIsOpen, recordTypeId }) => {
  const { getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.LEAD,
    recordTypeId
  );

  return (
    <ImportDataForm
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      recordTypeId={recordTypeId}
      importService={LeadService.importLeads}
      defaultFields={defaultImportFields.CRM_LEAD}
      filterEntity={POSSIBLE_FILTERS_ENTITIES.CRM_LEAD_IMPORT}
      getCustomFields={getCustomFields}
    />
  );
};

export default ImportLeadsModal;
